import axios, { ResponseType } from "axios";
import { globalModule } from "../service-provider/GlobalModule";

import { registerGlobalService } from "../service-provider/ServiceRegistry";

export interface UploadDownloadProgressInterface {
  (progressEvent: any): void;
}
export interface HttpConfig {
  headers?: any;
  responseType?: ResponseType;
  onUploadProgress?: UploadDownloadProgressInterface;
  onDownloadProgress?: UploadDownloadProgressInterface;
}
export interface GetFunction {
  (url: string, config?: HttpConfig): Promise<any>;
}
export interface PostFunction {
  (url: string, data: any, config?: HttpConfig): Promise<any>;
}

export interface PutFunction {
  (url: string, data: any, config?: HttpConfig): Promise<any>;
}

export interface DeleteFunction {
  (url: string, config?: HttpConfig): Promise<any>;
}

export interface PatchFunction {
  (url: string, data: any, config?: HttpConfig): Promise<any>;
}

export interface Http {
  get: GetFunction;
  post: PostFunction;
  put: PutFunction;
  delete: DeleteFunction;
  patch: PatchFunction;
}

export const noCacheAxios = axios.create({
  headers: {
    Pragma: "no-cache",
    "Cache-Control": "no-cache, no-store",
  },
});

export class HttpService implements Http {
  get = async (url: string, config?: HttpConfig) => {
    const response = await noCacheAxios.get(url, config);
    return { data: response.data, headers: response.headers, config: response.config };
  };

  post = async (url: string, data: any, config?: HttpConfig) => {
    return await noCacheAxios.post(url, data, config);
  };

  put = async (url: string, data: any, config?: HttpConfig) => {
    return await noCacheAxios.put(url, data, config);
  };

  delete = async (url: string, config?: HttpConfig) => {
    return await noCacheAxios.delete(url, config);
  };

  patch = async (url: string, data: any, config?: HttpConfig) => {
    return await noCacheAxios.patch(url, data, config);
  };
}

export const http = new HttpService();
globalModule.http = http;
export default registerGlobalService(http as Http);
